var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0.994141)",
    fill: "#BECDE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1541 22.22V12.56H12.7941V22.22H10.1541ZM11.4741 11C11.0475 11 10.6941 10.86 10.4141 10.58C10.1341 10.2867 9.99414 9.92667 9.99414 9.5C9.99414 9.08667 10.1341 8.73333 10.4141 8.44C10.6941 8.14667 11.0475 8 11.4741 8C11.9141 8 12.2675 8.14667 12.5341 8.44C12.8141 8.73333 12.9541 9.08667 12.9541 9.5C12.9541 9.92667 12.8141 10.2867 12.5341 10.58C12.2675 10.86 11.9141 11 11.4741 11Z",
    fill: "#373F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8151 22.22V16.68C21.8151 16.1067 21.6351 15.64 21.2751 15.28C20.9151 14.92 20.4484 14.74 19.8751 14.74C19.5017 14.74 19.1684 14.82 18.8751 14.98C18.5817 15.14 18.3484 15.3667 18.1751 15.66C18.0151 15.9533 17.9351 16.2933 17.9351 16.68L16.9151 16.16C16.9151 15.4 17.0751 14.74 17.3951 14.18C17.7284 13.6067 18.1817 13.16 18.7551 12.84C19.3417 12.52 20.0017 12.36 20.7351 12.36C21.4417 12.36 22.0751 12.54 22.6351 12.9C23.1951 13.2467 23.6351 13.7067 23.9551 14.28C24.2751 14.84 24.4351 15.4467 24.4351 16.1V22.22H21.8151ZM15.3151 22.22V12.56H17.9351V22.22H15.3151Z",
    fill: "#373F6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.67a261c5de33d061596c0f50b7b889b6.svg";
export { ForwardRef as ReactComponent };